import React, { useState } from 'react';
import { Shield, AlertCircle, CheckCircle2, Activity, TrendingUp } from 'lucide-react';

export const HypercareCenter = ({ project }) => {
  const [monitoring] = useState({
    active_incidents: 12,
    resolved_today: 8,
    avg_resolution_time_min: 45,
    error_clusters: [
      { pattern: 'ATP Check Failures in SD', frequency: 23, severity: 'high', rca: 'MRP Live not fully activated', fix: 'Complete PP/DS configuration' },
      { pattern: 'BP Role Errors in Finance', frequency: 18, severity: 'medium', rca: 'Incomplete BP migration', fix: 'Run BP consistency check BUPA_TEST' },
      { pattern: 'Slow CDS View Performance', frequency: 15, severity: 'medium', rca: 'Missing HANA indexes', fix: 'Create suggested indexes' }
    ],
    hot_transactions: [
      { tcode: 'VA01', error_count: 45, error_rate: 2.3, status: 'monitoring' },
      { tcode: 'MIGO', error_count: 34, error_rate: 1.8, status: 'resolved' },
      { tcode: 'FB01', error_count: 28, error_rate: 1.5, status: 'monitoring' }
    ],
    predicted_hotspots: [
      { area: 'Finance Period Close', probability: 0.78, recommendation: 'Schedule additional support' },
      { area: 'Month-End MRP Run', probability: 0.65, recommendation: 'Pre-validate master data' }
    ]
  });

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Hypercare Command Center</h2>
        <p className="text-gray-600">Monitor post go-live, detect patterns, predict failures (PATENT)</p>
      </div>

      <div className="grid md:grid-cols-4 gap-6">
        <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white shadow-lg">
          <AlertCircle className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{monitoring.active_incidents}</div>
          <div className="text-red-100 text-sm">Active Incidents</div>
        </div>
        <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
          <CheckCircle2 className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{monitoring.resolved_today}</div>
          <div className="text-green-100 text-sm">Resolved Today</div>
        </div>
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg">
          <Activity className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{monitoring.avg_resolution_time_min}min</div>
          <div className="text-blue-100 text-sm">Avg Resolution</div>
        </div>
        <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white shadow-lg">
          <TrendingUp className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{monitoring.error_clusters.length}</div>
          <div className="text-purple-100 text-sm">Error Patterns</div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-6">AI-Detected Error Patterns</h3>
        <div className="space-y-3">
          {monitoring.error_clusters.map((cluster, idx) => (
            <div key={idx} className="border-2 border-red-200 bg-red-50 rounded-lg p-5">
              <div className="flex items-start space-x-3 mb-3">
                <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-2">
                    <h4 className="font-semibold text-gray-900">{cluster.pattern}</h4>
                    <span className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full font-semibold">{cluster.frequency} occurrences</span>
                  </div>
                  <p className="text-sm text-gray-700 mb-2"><strong>RCA:</strong> {cluster.rca}</p>
                  <p className="text-sm text-green-600 font-semibold">✓ Fix: {cluster.fix}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-6">Predicted Failure Hotspots</h3>
        <div className="space-y-3">
          {monitoring.predicted_hotspots.map((hotspot, idx) => (
            <div key={idx} className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-semibold text-gray-900">{hotspot.area}</h4>
                <span className="text-lg font-bold text-orange-600">{Math.round(hotspot.probability * 100)}% risk</span>
              </div>
              <p className="text-sm text-gray-600">✓ {hotspot.recommendation}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HypercareCenter;